module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.7@core-js/library/modules/_redefine.js
// module id = 40
// module chunks = 0